if (!customElements.get('sensen-hero-slideshow')) {
  class SensenHeroSlideshow extends HTMLElement {
    constructor() {
      super();
      this.slides = [];
      this.dots = [];
      this.currentSlide = 0;
      this.timer = null;
      this.observer = null;
      this.nextSlide = this.nextSlide.bind(this);
      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    }

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.sensen-hero-slide'));
      this.dots = Array.from(this.querySelectorAll('.sensen-hero-dot'));

      if (this.slides.length <= 1) return;

      this.initEvents();
      this.initObserver();
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      this.stopSlideshow();
    }

    initEvents() {
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.goToSlide(index);
          this.restartSlideshow();
        });
      });

      let touchStartX = 0;
      let touchStartY = 0;

      this.addEventListener('touchstart', (e) => {
        if (!e.touches || e.touches.length === 0) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });

      this.addEventListener('touchend', (e) => {
        if (!e.changedTouches || e.changedTouches.length === 0) return;
        const touchEndX = e.changedTouches[0].clientX;
        const touchEndY = e.changedTouches[0].clientY;

        const diffX = touchEndX - touchStartX;
        const diffY = touchEndY - touchStartY;

        if (Math.abs(diffX) > 40 && Math.abs(diffX) > Math.abs(diffY)) {
          if (diffX < 0) {
            this.nextSlide();
          } else {
            this.prevSlide();
          }
          this.restartSlideshow();
        }
      }, { passive: true });

      document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }

    prevSlide() {
      const prevIndex = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
      this.goToSlide(prevIndex);
    }

    initObserver() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !document.hidden) {
            this.startSlideshow();
          } else {
            this.stopSlideshow();
          }
        });
      });

      this.observer.observe(this);
    }

    handleVisibilityChange() {
      if (document.hidden) {
        this.stopSlideshow();
      } else {
        this.startSlideshow();
      }
    }

    startSlideshow() {
      if (this.timer || this.slides.length <= 1) return;
      const intervalSeconds = parseInt(this.dataset.interval, 10) || 5;
      this.timer = setInterval(this.nextSlide, intervalSeconds * 1000);
    }

    stopSlideshow() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    restartSlideshow() {
      this.stopSlideshow();
      this.startSlideshow();
    }

    nextSlide() {
      const nextIndex = (this.currentSlide + 1) % this.slides.length;
      this.goToSlide(nextIndex);
    }

    goToSlide(index) {
      if (index === this.currentSlide || !this.slides[index]) return;

      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });

      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });

      this.currentSlide = index;
    }
  }

  customElements.define('sensen-hero-slideshow', SensenHeroSlideshow);
}
